import { Box, Tooltip, Typography } from '@mui/material';

const XCurrencyField = ({
  value,
  sx,
  currency = { symbol: '', position: 'before', space: false },
  colorize = false,
}: {
  value: number;
  sx?: object;
  currency?: {
    symbol: string;
    position?: 'before' | 'after';
    space?: boolean;
  };
  colorize?: boolean;
}) => {
  const formatCompactNumber = (value: number): string => {
    if (!value && value !== 0) return '-';

    const absValue = Math.abs(value);
    if (absValue < 0.01 && absValue > 0) {
      return value.toFixed(6);
    } else if (absValue >= 1e9) {
      return (value / 1e9).toFixed(2) + 'B';
    } else if (absValue >= 1e6) {
      return (value / 1e6).toFixed(2) + 'M';
    } else if (absValue >= 1e3) {
      return (value / 1e3).toFixed(2) + 'K';
    } else {
      return value.toFixed(2);
    }
  };

  const getColor = () => {
    if (!colorize || value === 0 || !value) return undefined;
    return value > 0 ? 'success.main' : 'error.main';
  };

  const renderValue = `${currency.position === 'before' ? currency.symbol : ''}${currency.space ? ' ' : ''}${formatCompactNumber(value)}${currency.space ? ' ' : ''}${currency.position === 'after' ? currency.symbol : ''}`;
  const renderTooltip = `${currency.position === 'before' ? currency.symbol : ''}${currency.space ? ' ' : ''}${value}${currency.space ? ' ' : ''}${currency.position === 'after' ? currency.symbol : ''}`;

  return (
    <Box display="flex" alignItems="center" sx={sx}>
      <Tooltip title={value !== undefined && value !== null ? renderTooltip : '-'}>
        <Typography variant="body2" color={getColor()}>{renderValue}</Typography>
      </Tooltip>
    </Box>
  );
};

export default XCurrencyField;
